// extracted by mini-css-extract-plugin
export default {"hidden":"mn0Hf"};